export const DIDOMI_GOOGLE_CONSENT = 'didomi:google';
export const GA_ACTIVE_SESSION_COOKIE_NAME = '_gaActiveSession';

export const SITE_TYPE: { [key: string]: string } = {
  mobile: 'M',
  desktop: 'D',
  tablet: 'T',
};
